module.exports = __webpack_public_path__ + "img/unionpay@2x.ddf3c41e.png";